import Navbar from "../component/landingPage/navigation/Navbar";
import Footer from "../component/common/Footer";
import "../asset/sass/global.scss";
import background from "../asset/lotties/bg1.json";
import Lottie from "lottie-react";
import styles from "./Support.module.scss";
import { useRef, useState } from "react";

export default function Support() {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [filePreview, setFilePreview] = useState<string | null>(null);
  const [showPopup, setShowPopup] = useState(false);

  function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files && e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (ev) => {
        setFilePreview(ev.target?.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setFilePreview(null);
    }
  }

  function handleFileBoxClick() {
    if (fileInputRef.current) fileInputRef.current.click();
  }

  function handleFormSubmit(e: React.FormEvent) {
    e.preventDefault();
    setShowPopup(true);
  }

  return (
    <>
      <header className={`${styles["new-header"]} header`}>
        <div className="hero-overlay">
          <Lottie animationData={background} className="backgroundImage" />
        </div>
        <Navbar />
        <main className={styles["support-section"]}>
          <div className={styles["support-section__wrapper"]}>
            <div className={styles["contact-form-card"]}>
              <h1 className={styles["contact-title"]}>
                Contact <span className={styles["text-purple"]}>PLAYBOX</span>
              </h1>
              <p className={styles["contact-subtitle"]}>
                Our friendly support team is here to help you.
              </p>
              <form
                className={styles["contact-form"]}
                onSubmit={handleFormSubmit}
              >
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="firstName">Full name</label>
                    <div className={styles["form-row-inline"]}>
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        placeholder="First name"
                        autoComplete="given-name"
                        required
                      />
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        placeholder="Last name"
                        autoComplete="family-name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="email">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="name@example.com"
                      autoComplete="email"
                      required
                    />
                  </div>
                </div>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="phone">
                      Phone number{" "}
                      <span className={styles.optional}>(Optional)</span>
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      placeholder="e.g. +1 555 123 4567"
                      autoComplete="tel"
                    />
                  </div>
                </div>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="message"
                      rows={4}
                      placeholder="How can we help you?"
                      required
                    />
                  </div>
                </div>
                <div className={styles["form-row"]}>
                  <div className={styles["form-group"]}>
                    <label htmlFor="file">
                      Attach file{" "}
                      <span className={styles.optional}>(Optional)</span>
                    </label>
                    <div
                      className={styles["file-upload"]}
                      onClick={handleFileBoxClick}
                    >
                      <input
                        type="file"
                        id="file"
                        name="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        accept=".png,.jpg,.jpeg,.pdf,.gif,.svg"
                        onChange={handleFileChange}
                      />
                      <div className={styles["file-upload-box"]}>
                        {filePreview ? (
                          <div className={styles["file-image-preview"]}>
                            <img src={filePreview} alt="Preview" />
                          </div>
                        ) : (
                          <>
                            <span className={styles["file-upload-icon"]}>
                              🗂️
                            </span>
                            <span>Click to upload your image</span>
                            <span className={styles["file-upload-types"]}>
                              PNG, JPG, PDF, GIF, SVG (Max 5 MB)
                            </span>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles["form-actions"]}>
                  <button type="submit" className={styles["primary-btn"]}>
                    Send message
                  </button>
                  <button type="button" className={styles["secondary-btn"]}>
                    Schedule a call
                  </button>
                </div>
              </form>
            </div>
          </div>
        </main>
      </header>
      {showPopup && (
        <div className={styles["popup-overlay"]}>
          <div className={styles["popup"]}>
            <h2>Message Sent!</h2>
            <p>
              Your message has been sent. Our team will get back to you soon.
            </p>
            <button
              onClick={() => setShowPopup(false)}
              className={styles["popup-btn"]}
            >
              Close
            </button>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}
